module.exports = __webpack_public_path__ + "static/media/c.d84b4cde.jpg";